import { useTranslation } from "react-i18next";

import ShareLinkDialog from "../../../../shared/ui/share/ShareLinkDialog";
import type { RemoteBoard } from "../../application/useBoardRelay";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    remote: RemoteBoard;
};

/**
 * The board's link for a patient who is not in the consulting room, and
 * whether they have opened it. Opening it needs no account; it shows the
 * stimulus and the stop button, nothing else.
 */
export default function ShareBoardDialog({ isOpen, onClose, remote }: Props) {
    const { t } = useTranslation();
    const { status, shareUrl, patientPresent, share } = remote;

    return (
        <ShareLinkDialog
            isOpen={isOpen}
            onClose={onClose}
            title={t("emdr.share.title")}
            subtitle={t("emdr.share.subtitle")}
            status={status === "live" ? "ready" : status === "failed" ? "failed" : "loading"}
            url={shareUrl}
            message={shareUrl ? t("emdr.share.message", { url: shareUrl }) : ""}
            onRetry={() => void share()}
            presence={patientPresent ? t("emdr.share.connected") : t("emdr.share.waiting")}
            footnote={t("emdr.share.expiry")}
        />
    );
}
